module.exports = __webpack_public_path__ + "static/media/P440sq-b_1.1a96266a.jpeg";